import { render, staticRenderFns } from "./properties-website-style.vue?vue&type=template&id=10828652&scoped=true"
import script from "./properties-website-style.vue?vue&type=script&lang=js"
export * from "./properties-website-style.vue?vue&type=script&lang=js"
import style0 from "./properties-website-style.vue?vue&type=style&index=0&id=10828652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10828652",
  null
  
)

export default component.exports